import { createContext, useContext } from "react";

export interface PollingContextValue<PollingValue, CachedData> {
  setPollingValue: (args: { key: string; value: PollingValue }) => void;
  setPollingValues: (args: { key: string; value: PollingValue }[]) => void;
  getPollingValue: (key: string) => PollingValue | null;
  getPollingValues: () => Record<string, PollingValue>;
  clearPollingValue: (key: string) => void;

  setCachedData: (args: { key: string; data: CachedData }) => void;
  getCachedData: (key: string) => CachedData | null;
  getAllCachedData: () => Record<string, CachedData>;

  isAnyPolling: boolean;
  isAnyCached: boolean;
}

export const PollingContext = createContext<PollingContextValue<
  string,
  any
> | null>(null);

export const usePollingContext = () => {
  const context = useContext(PollingContext);
  if (!context) {
    throw new Error("usePolling must be used within a PollingProvider");
  }
  return context;
};
